import { render } from "./login-modal.vue?vue&type=template&id=3bf83888&ts=true"
import script from "./login-modal.vue?vue&type=script&lang=ts"
export * from "./login-modal.vue?vue&type=script&lang=ts"

import "./login-modal.vue?vue&type=style&index=0&id=3bf83888&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__